const TRUST_ITEMS = [
  { icon: 'ri-shield-check-line', label: 'Licensed & Insured' },
  { icon: 'ri-building-2-line', label: 'Commercial Specialists' },
  { icon: 'ri-virus-line', label: 'GBAC COVID-19 Certified' },
  { icon: 'ri-thumb-up-line', label: 'Satisfaction Guaranteed' },
  { icon: 'ri-government-line', label: 'GSA Federal Contractor' },
  { icon: 'ri-medal-line', label: 'BBB Accredited' },
];

export default function SharedTrustBar() {
  return (
    <section className="bg-white border-y border-gray-100 py-5">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-wrap items-center justify-center gap-6 lg:gap-0 lg:justify-between">
          {TRUST_ITEMS.map((item) => (
            <div key={item.label} className="flex items-center gap-2.5 cursor-default group">
              <div className="w-8 h-8 flex items-center justify-center bg-accent/10 rounded-lg group-hover:bg-accent/20 transition-colors shrink-0">
                <i className={`${item.icon} text-accent text-base`}></i>
              </div>
              <span className="text-navy font-body font-semibold text-sm whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
